import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { regionalRateService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import { RegionalRateForm } from '../components/RegionalRateForm';
import { IRegionalRate } from '../types';

export const EditRegionalRate = () => {
  const translationPrefix = 'pages.regional-rate.edit';
  const { regionalRateId } = useParams();
  const [regionalRate, setRegionalRate] = useState<IRegionalRate>();

  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    regionalRateService.get(+regionalRateId).then(setRegionalRate);
  }, []);

  const updateType = async (values) => {
    dispatch(loadingActions.startLoading());
    regionalRateService.update(regionalRate.id, values).then(() => {
      toast.crud.successUpdate('Tariffa', 'f');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={regionalRate?.code}>
      <RegionalRateForm regionalRate={regionalRate} onSubmit={updateType} />
    </TenantPage>
  );
};

export default EditRegionalRate;
